import React from 'react';
import {ErrorMessageProps, ErrorsType} from './ErrorsType';
import {HttpError} from '../../../../api/client';
import {InternalServerErrorMessage} from './InternalServerErrorMessage';
import {DefaultErrorMessage} from './DefaultErrorMessage';
import {BadRequestMessage} from './BadRequestMessage';
import {UnauthorizedMessage} from './UnauthorizedMessage';
import {ForbiddenMessage} from './ForbiddenMessage';


const CompoundMessage = (props: ErrorMessageProps) => {
  console.log(props);
  if((typeof (props.error as HttpError).data) !== 'undefined' && (props.error as HttpError).statusCode === ErrorsType.Forbidden)
    return <ForbiddenMessage {...props}/>;
  if((typeof (props.error as HttpError).data) !== 'undefined' && (props.error as HttpError).statusCode === ErrorsType.Unauthorized)
    return <UnauthorizedMessage {...props}/>;
  if ((typeof (props.error as HttpError).data) !== 'undefined' && (props.error as HttpError).statusCode === ErrorsType.BadRequest)
    return (<BadRequestMessage {...props}/>);
  if ((typeof (props.error as HttpError).data) !== 'undefined' && (props.error as HttpError).statusCode === ErrorsType.InternalServerError)
    return (<InternalServerErrorMessage {...props}/>);
  return <DefaultErrorMessage {...props}/>;
};

export default CompoundMessage;
